import type { HttpService } from '@storebrand-digital/bank-foundation-http-service';

import ApiRoutePath from '../constants/apiRoutePath';
import type {
  CreditCardApplicationPayload,
  DecreaseCreditCardLimitPayload,
  CreditCard,
  TerminateCreditCardPayload,
} from '../types';

export default class CreditCardService {
  #httpService: HttpService;

  constructor(httpService: HttpService) {
    this.#httpService = httpService;
  }

  hasOnboarded = async () =>
    this.#httpService
      .get<boolean>(ApiRoutePath.GET_CUSTOMER_HAS_ONBOARDED)
      .then(({ data }) => data);

  getCreditCards = async () =>
    this.#httpService
      .get<CreditCard[] & { status: number }>(ApiRoutePath.GET_CREDIT_CARD)
      .then(({ data, status }) => {
        if (status === 204) {
          return [];
        }
        return data;
      });

  applyForCreditCardOrIncreaseLimit = async (
    payload: CreditCardApplicationPayload
  ) =>
    this.#httpService.post(
      ApiRoutePath.POST_APPLY_OR_MODIFY_FOR_CREDIT_CARD,
      payload
    );

  applyForDecreaseCreditLimit = async (
    payload: DecreaseCreditCardLimitPayload
  ) => this.#httpService.post(ApiRoutePath.POST_DECREASE_CREDIT_LIMIT, payload);

  postTerminateCreditCard = async (payload: TerminateCreditCardPayload) =>
    this.#httpService.post(ApiRoutePath.POST_TERMINATE_CREDIT_CARD, payload);
}
